import $ from "jquery";

/**
 * Load Matomo Tracking Code.
 **/
export const initMatomoTracker = () => {
    var config;
    $.getJSON(process.env.MATOMO_CONFIG, function(config) {
        $(function() {
            //Matomo
            var _paq = window._paq = window._paq || [];
            /* tracker methods like "setCustomDimension" should be called before "trackPageView" */
            _paq.push(['requireCookieConsent']);
            _paq.push(["setCookieDomain", "*.orca.nrw"]);
            _paq.push(["setDomains", "*.orca.nrw"]);
            _paq.push(['addDownloadExtensions', "mbz"]);
            // _paq.push(['trackPageView']);
            // _paq.push(['enableLinkTracking']);
            (function() {
                _paq.push(['setTrackerUrl', config.matomoUrl+'/matomo.php']);
                _paq.push(['setSiteId', config.siteId]);
                var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
                g.type='text/javascript'; g.async=true; g.src=config.matomoUrl+'/matomo.js'; s.parentNode.insertBefore(g,s);
            })();
        });
    });
}
